<template>
  <div>
    <ViewTemplateReportList
      :panel="panel"
      :reports="reports"
    />
  </div>
</template>

<script>
import ViewTemplateReportList from "@nixweb/nixloc-ui/src/component/template/ViewTemplateReportList";

export default {
  name: "ReportFinanceStockView",
  components: { ViewTemplateReportList },
  data() {
    return {
      panel: {
        module: "Financeiro",
        title: "Relatório",
        showFilter: false,
        showSearch: true,
        showButtons: false,
      },
      reports: {
        default: [
          {
            name: "Relatório de contas pagar e receber",
            routeName: "reportPayableReceivable",
          },
          {
            name: "Relatório de desempenho financeiro",
            routeName: "drePayableReceivable",
            showNewUntil: "30/08/2025",
          },
          {
            name: "Relatório de receita x despesa de locação",
            routeName: "reportRentPerformance",
          },
        ],
        saved: [],
      },
    };
  },
};
</script>
